import React from 'react';
import { connect } from "react-redux";
import {withRouter} from 'react-router-dom';
import { CollectionCard } from './CollectionCard';



class AffiliateMainBanner extends React.Component{

    render(){
        var collectionList = this.props.fromAffiliate;
        var content = [];
        if(collectionList.length){
            collectionList.forEach(element => {
                content.push(
                <div className="col-xl-3 col-sm-12 col-md-4 col-lg-3" key={element.collection_id}>
                    <CollectionCard parentUrl={this.props.match.url} {...element}/>
                </div>
                )
            })
        }
        return (
            
            <div className="row">
            <div className="col-xl-12 col-sm-12 col-md-12 col-lg-12">
            <p style={{margin:'0 0 1rem'}}>{content.length} Collections</p>
            </div>
                {content}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        fromAffiliate: state.collections.fromAffiliate,
        contentLoading: state.contentLoading,
        pageLoading: state.pageLoading,
    };
};
export default withRouter(connect(mapStateToProps)(AffiliateMainBanner));


// WEBPACK FOOTER //
// ./src/AffiliateLandingPage/CollectionListing.jsx